import { lang } from '@public/utils/filters'

export default {
  Q_status: [
    { value: 1, label: lang('待处理(申报代理区处理)'), name: lang('待处理(申报代理区处理)') },
    { value: 2, label: lang('待审核(责任代理区处理)'), name: lang('待审核(责任代理区处理)') },
    { value: 3, label: lang('已审核(责任网点处理)'), name: lang('已审核(责任网点处理)') },
    { value: 4, label: lang('已驳回(申报网点处理)'), name: lang('已驳回(申报网点处理)') },
    { value: 5, label: lang('已申诉(总部处理)'), name: lang('已申诉(总部处理)') },
    { value: 6, label: lang('已结案(处理完成)'), name: lang('已结案(处理完成)') },
    { value: 7, label: lang('已撤销(无需处理)'), name: lang('已撤销(无需处理)') },
    { value: 8, label: lang('已出账(已生成流水)'), name: lang('已出账(已生成流水)') }
  ],
  Q_operationType: [
    { value: 1, label: lang('提交'), name: lang('提交') },
    { value: 2, label: lang('通过'), name: lang('通过') },
    { value: 3, label: lang('撤销'), name: lang('撤销') },
    { value: 4, label: lang('驳回'), name: lang('驳回') },
    { value: 5, label: lang('结案'), name: lang('结案') },
    { value: 6, label: lang('申诉到总部'), name: lang('申诉到总部') },
    { value: 7, label: lang('请求重审'), name: lang('请求重审') },
    { value: 8, label: lang('请求代理区介入'), name: lang('请求代理区介入') },
    { value: 9, label: lang('申报'), name: lang('申报') },
    { value: 10, label: lang('修改金额'), name: lang('修改金额') }
  ],
  Q_statusResponsibleStatus: [
    // 0未申诉 1已申诉
    { value: 1, label: lang('未申诉'), name: lang('未申诉') },
    { value: 2, label: lang('已申诉'), name: lang('已申诉') }
  ]
}